import { ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AppointmentStatus, AppointmentType, IAvailability, IAvailabilityOptions, IDeliveryAppointment, IGeneralSettingsAppointmentRequest, ITransportOption, LocationType } from '@signal/asp-data-commons';
import { TimeSlot } from '../../shared/models/time-slot';
import { AspBannerService } from '../../shared/services/asp-banner.service';
import { confirmConfig, convertMinsToHourMins, unsubscribeSubscriptions,countryCd } from '../../shared/services/util.service';
import * as fromSelectors from '../../store/sales-appointment/sales-appointment.selectors';
import * as fromActions from '../../store/sales-appointment/sales-appointment.actions';
import { Store } from '@ngrx/store';
import { SalesAppointmentState } from '../../store/sales-appointment/sales-appointment.reducer';
import { iif, Observable, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { DateTime } from 'luxon';
import _ from 'lodash';
import { SubscriptionList } from '../../shared/models/asp.types';
import { IAddress, IAppointment, ICustomer, IVehicleDetails } from '@signal/asp-data-commons/lib/interfaces/appointment';
import { SearchCustomersState } from '../../store/search-customers/search-customers.reducer';
import { selectCurrentCustomer } from '../../store/search-customers/search-customers.selectors';
import { SettingsState } from '../../store/settings/settings.reducer';
import { LoadSettings } from '../../store/settings/settings.actions';
import { TranslateService} from '@ngx-translate/core';
import * as fromValidator from '../service-appointment/service-appointment.validator';
import { VehicleService } from '../../shared/services/vehicle.service';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DealerState } from '../../store/dealer/dealer.reducer';
import * as fromSelector from '../../store/dealer/dealer.selectors';
import { VehicleStatus } from '@signal/asp-data-commons/lib/enums/enum';
import { AvailabilityComponent } from '../../shared/components/availability/availability.component';
import * as fromSettingsSelectors from "../../store/settings/settings.selectors";
import { CustomerType } from '../../shared/enums/customer-types.enum';

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit,OnDestroy {
  from: string;
  enableSubmitButton=true;
  isSaveForLaterSubmitting = false;
  saveAndSendLink = false;
  loadingAvailability = false;
  signedIn: boolean;
  appointmentId: string;
  location: string;
  preferredDate: string;
  preferredTime: string;
  lastName = '';
  email = '';
  firstName = '';
  isSubmitting = false;
  apptType: string = AppointmentType.DELIVERY;
  availabilityOptions$: Observable<IAvailabilityOptions>;
  availabilityOptionsLoading$: Observable<boolean>;
  customerDetails$: Observable<ICustomer>;
  availability$: Observable<IAvailability>;
  availabilityLoading$: Observable<boolean>;
  time$: Observable<any>;

  vehicleDetails: any = {
    yearMakeModel: '',
    vin: '',
    stockNo: 'NA',
    trim: 'XE',
    certificationStatus:'',
    source:'',
    make:'',
    dealerCategory:'',
    dealerSubCategory:'',
    estimatedDealerArrival:'',
    dealerCode:'',
    unitId:123,
    isTestDrive: false,
    isSafetyCampaign:false,
    isNonSafetyCampaign:false,
  };
  hasRemoteLocation = false;
  hasremoteLocationType = false;
  timeSlots: TimeSlot[] = [];
  transport;
  isValidRemoteZip:boolean;
  isUpdate: boolean = false;
  showMandatoryMsgCI:boolean = false;
  lastValue
  isStoreUpdate = false;
  storeValue;
  isFirstTime=false;
  transportOptions$: Observable<ITransportOption[]>;
  deliveryForm: UntypedFormGroup;
  callAvailability=true;
  private tradeInForm: UntypedFormControl;
  availability: UntypedFormControl;
  private customerForm: UntypedFormControl;
  private contactEmailInfoForm: UntypedFormControl;
  remoteZipcodes$: Observable<string[]>;
  remoteValidZipcodes: { pmaZipCodes: string[], isRemote: boolean };
  yearList$: Observable<number[]>;
  private subscriptions: SubscriptionList = {};
  private signedInUserDetails: ICustomer;
  searchVinForm:UntypedFormGroup;
  load:boolean = false;
  isVinValid:boolean = false;
  dateFormat : string = 'yyyy-MM-dd';
  formChanged=true;
  aptType = AppointmentType.DELIVERY;
  toShowButton$: Observable<boolean>;
  dealerCode$: Observable<string>;
  dealerCode:string;
  message:string;
  date:string;
  customerName:string;
  appointments=[];
  appointment:IAppointment;
  appType="";
  data:any;
  languageId='';
  totalDuration:any;
  customerDataOnEdit;
  showSplitter = false;
  showStatusLabel=false;
  vehicleStatusLabel='';
  calenderMessage='';
  settings:IGeneralSettingsAppointmentRequest={} as IGeneralSettingsAppointmentRequest;

  @ViewChild(AvailabilityComponent, { static: false }) AvailabilityComponent: AvailabilityComponent;
  paramVin: any;
  sourcetype="";

  constructor(
    private readonly viewportScroller: ViewportScroller,
    private readonly dialog: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly bannerService: AspBannerService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly translateService:TranslateService,
    private readonly salesAppointmentState: Store<SalesAppointmentState>,
    private readonly searchCustomersState: Store<SearchCustomersState>,
    private readonly settingsState: Store<SettingsState>,
    private readonly translate : TranslateService,
    private readonly vehicleService:VehicleService,
    private readonly dealerState: Store<DealerState>,
    private readonly cdref: ChangeDetectorRef
  ) {
  
    this.apptType = AppointmentType.DELIVERY;
    this.location = 'D001';
    this.settingsState.dispatch(new LoadSettings({department: 'sales'}));
    this.searchVinForm = this.formBuilder.group({
      isOwnVehicle: [false],
      isInputVinBased: [true],
      vin: ['',[Validators.required]],
      mileage:[1]
    })
    this.searchVinForm.setValidators(fromValidator.chooseVehicleValidator());
    this.initializeDeliveryForm();
    this.subscriptions.vinForm=this.searchVinForm.valueChanges.subscribe(_vin=> {
      this.formChanged=!this.searchVinForm.dirty;
    });
    this.subscriptions.queryParams=this.route.queryParams.subscribe(params => {
      this.appointmentId = params.id;
      this.from = params.from;
      if(params.vin) {
        this.paramVin = params.vin;
        this.sourcetype = params.source;
        this.searchVinForm.patchValue({
          isOwnVehicle: false,
          isInputVinBased: true,
          vin: this.paramVin
        });
      }
      if (this.appointmentId) {
        this.load = true;
        this.salesAppointmentState.dispatch(new fromActions.GetEditData
          ({appointmentType: AppointmentType.DELIVERY, appointmentId: this.appointmentId }));
        this.isUpdate = true;
      }
      if(!this.isUpdate){
        this.load = false;
      }
      this.dealerCode$ = this.dealerState.select(fromSelector.selectDealerCode); 
      this.subscriptions.dealerCode=this.dealerCode$.subscribe(code=>{
        this.dealerCode=code;
      });
    });
  }

  checkIfAvaiabilityValid() {
    return this.AvailabilityComponent?.timeSlots?.filter(slot => slot?.timeSlotId === this.AvailabilityComponent?.oldValue?.timeSlotId)[0]?.isOpen
  }

  isDeliveryFormValid() {
    return (this.appointmentId ? true : this.isVinValid) &&
      this.checkIfAvaiabilityValid() &&
      this.loadingAvailability &&
      this.deliveryForm.controls.availability.value.advisorId &&
      this.deliveryForm.controls.availability.value.languageId &&
      this.deliveryForm.controls.transportationTypeCode.valid &&
      this.deliveryForm.controls.address.valid &&
      this.deliveryForm.controls.tradeIn.valid &&
      this.deliveryForm.controls.remoteZipCode.valid &&
      this.deliveryForm.controls.vehicle.valid && this.checkCustomerFormOnSubmit();
  }

  isValidForm() {
    const apptStartDate = this.deliveryForm.get('availability').value?.appointmentStartDate || "";
    const currentDate = DateTime.fromISO(DateTime.now().toString())
      .toFormat(this.dateFormat);
    return this.isDeliveryFormValid() && apptStartDate >= currentDate
  }

  canExit():Observable<boolean> { 
    let dialogRef;
    const result = new Subject<boolean>();
    dialogRef = this.dialog.open(ConfirmDialogComponent, confirmConfig);
    this.subscriptions.dialog=dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
      }
      else if(event.action === 'close'){
        result.next(true);
        result.complete();
       }else{}
    });
  return result.asObservable(); 
  };

  formsNotEdited()
  {
    return this.formChanged;
  }

  valuesChanges(event)
  {
    this.formChanged=event;
  }

  isCIformValid(event) {
    this.showMandatoryMsgCI = event;
  }


  ngAfterContentChecked() {
    if (!this.cdref['destroyed']) {
      this.cdref.detectChanges();
    }
  }

  initializeDeliveryForm() {
    this.load = true;
    this.deliveryForm = this.formBuilder.group({
      vehicle: this.formBuilder.group({
        exteriorColor: null,
        model: null,
        trim: null,
        year: null,
        make: null,
        imageUrl: null,
        vin: null,
        dealerCategory:null,
        unitId:null,
        source:null,
        dealerCode:null,
        isSafetyCampaign:null,
        isNonSafetyCampaign:null,
        onGroundDate: [''],
      }),
      tradeIn: this.tradeInForm,
      address: this.customerForm,
      transportationTypeCode: ['', [Validators.required]],
      remoteZipCode: [''],
      availability: this.availability,
      customer: this.contactEmailInfoForm
    });
    this.deliveryForm.controls.remoteZipCode.setValidators(this.zipValidator());
    this.onValueChange();
  }

  hasError(controlName: string, errorName: string){
    return this.searchVinForm[controlName].length ? false:true;
  }

  submitVinForm(){
    if (this.searchVinForm.valid) {
      this.load = true;
      this.vehicleDetails.isAlreadyBooked=false;
      this.enableSubmitButton=true;
      const vin=this.searchVinForm.get('vin').value ;
      this.subscriptions.vehicleDetails=this.vehicleService.getVehicleDetails({vin}).subscribe(result => {
        if (result.data.length){
          this.data = result.data[0];
          this.subscriptions.existingAppts=this.vehicleService.checkAppointmentsForVin(vin).subscribe(data=>{
            const result = data?.data;
            if(result.length)
            {
              this.groupAppointments(result);
            }else{
              this.getVehicleDetails();
            }
          });
        }
        else{
          this.load = false
          this.isVinValid = false
          this.vehicleDetails.isInvalid = true
          this.vehicleDetails.yearMakeModel = ''
          this.vehicleDetails.vin = ''
          this.vehicleDetails.isDealerDifferent=false;
        }
      });
    }
  }

  paramVinSearch(value){
  if(this.searchVinForm.valid && this.paramVin && value?.address?.addressLine1) {
      this.load=true;
      this.vehicleDetails.isAlreadyBooked=false;
      this.enableSubmitButton=true;
      const vin=this.searchVinForm.get('vin').value;
      iif(
              () => !!this.sourcetype,
              this.vehicleService.getVehicleDetails({vin, source: this.sourcetype}),
              this.vehicleService.getVehicleDetails({vin})
            ).subscribe(result => {
        if (result.data.length){
          this.data = result.data[0];
          this.subscriptions.existingAppts=this.vehicleService.checkAppointmentsForVin(vin).subscribe(data=>{
            const result = data?.data;
            if(result.length)
            {
              this.groupAppointments(result);
            }else{
              this.getVehicleDetails();
            }
            this.paramVin='';
            this.sourcetype='';
            this.load=false;
          });
        }
        else{
          this.load = false
          this.isVinValid = false
          this.vehicleDetails.isInvalid = true
          this.vehicleDetails.yearMakeModel = ''
          this.vehicleDetails.vin = ''
          this.vehicleDetails.isDealerDifferent=false;
          this.paramVin='';
          this.sourcetype='';
        }
      });
    }
  }

  getDeliveryApptForParamVinSearch(result) {
    let appointments = [];
    let appointment;
    const groupByAppType=_.groupBy(result,app=>app.appointmentType);
    if(groupByAppType.hasOwnProperty('Delivery'))
    {
      appointments = groupByAppType['Delivery'][0];
    }
    if(appointments.length)
    {
      appointments.sort((app1,app2)=>new Date(app1?.appointmentStartDate).getTime()- new Date(app2?.appointmentStartDate).getTime());
      appointment=this.appointments[0];
    }
    if(appointment?.appointmentStatus === AppointmentStatus.SAVED) {
      this.salesAppointmentState.dispatch(new fromActions.GetEditData
          ({appointmentType: AppointmentType.DELIVERY, appointmentId: appointment.appointmentId }));
    }
  }

  groupAppointments(result)
  {
    this.appointments=[];
    const groupByAppType=_.groupBy(result,app=>app.appointmentType);
    if(groupByAppType.hasOwnProperty('Delivery'))
    {
      this.appointment=groupByAppType['Delivery'][0];
    }
    else if(groupByAppType.hasOwnProperty('Test Drive'))
    {
      this.appointments=groupByAppType['Test Drive'];
    }
    else if(groupByAppType.hasOwnProperty('Learning'))
    {
      this.appointments=groupByAppType['Learning'];
    }
    else{
      this.appointments=groupByAppType['Service'];
    }

    if(this.appointments.length)
    {
      this.appointments.sort((app1,app2)=>new Date(app1?.appointmentStartDate).getTime()- new Date(app2?.appointmentStartDate).getTime());
      this.appointment=this.appointments[0];
    }
    this.appType=this.appointment?.appointmentType;
    this.date = (this.appointment?.appointmentStartDate) ? `${DateTime.fromISO(this.appointment?.appointmentStartDate).toFormat('MMMM dd')}`: "";
    this.customerName = this.appointment?.customer ? `${this.appointment.customer?.firstName} ${this.appointment.customer?.lastName}` : "";
    if (this.appType === AppointmentType.DELIVERY) {
      switch(this.appointment.appointmentStatus){
        case AppointmentStatus.SAVED:
          if(this.paramVin) {
            this.load=false; 
            const navigationExtras: NavigationExtras = {
              queryParams: {
                id: this.appointment.appointmentId
              }
            };
            this.router.navigate(['asp/bdc/delivery'], navigationExtras);
          } else {
            this.message = 'delivery.pendingDeliveryAppointment'
          }
          break;
        case AppointmentStatus.COMPLETED:
          this.message = 'delivery.completedDeliveryAppointment'
          break;
        default:
          this.message = 'delivery.deliveryAppointment'
      }
    }
    else if (this.appType === AppointmentType.TEST_DRIVE) {
        this.message = 'delivery.testDriveAppointmentWithCustomer';
    }
    else if (this.appType === AppointmentType.LEARNING) {
      this.message = 'delivery.learningAppointment';
    }
    else {
      this.message = 'delivery.serviceAppointment';
    }

    if(this.appType!==this.apptType)
    {
      this.getVehicleDetails();
    }
    else{
      this.vehicleDetails= {
        yearMakeModel: '',
        vin: '',
        stockNo: '',
        trim: '',
        source:'',
        make:'',
        dealerCategory:'',
      };
      this.isVinValid=false;
      this.load=false;
    }
    this.vehicleDetails.isAlreadyBooked=true;
  }

  getVehicleDetails()
  {
    if(this.data.vin && this.data.make && this.data.description && this.data.year) {
      const vehicleData={...this.vehicleDetails,
      vin : this.data.vin,
      yearMakeModel : (this.data?.model) ?`${this.data.year} ${this.data.make} ${this.data.model}` :`${this.data.year} ${this.data.make} ${this.data.description}`,
      isInvalid : false,
      make: this.data.make,
      certificationStatus: this.data?.certificationStatus,
      source: this.data.source,
      stockNo: this.data?.stockNo || "NA",
      unitId: this.data?.unitId,
      dealerCode: this.data.dealerCode,
      dealerCategory: this.data.dealerCategory,
      dealerSubCategory: this.data?.dealerSubCategory,
      estimatedDealerArrival: this.data.estimatedDealerArrival,
      isDealerDifferent: this.data.dealerCode!==this.dealerCode,
      isInvalidCategory: this.data.dealerCategory===VehicleStatus.A ||  this.data.dealerCategory===VehicleStatus.F ,
      isSafetyCampaign:this.data.isSafetyCampaign,
      isNonSafetyCampaign:this.data.isNonSafetyCampaign,
      };
      this.load = false;
      this.bannerService.showCarImage();
      this.bannerService.update(this.data.imageUrl);
      this.vehicleDetails={...vehicleData};
      this.deliveryForm.get('vehicle').patchValue({
        model: this.data?.model || this.data?.description,
        year: this.data.year,
        make: this.data.make,
        imageUrl: this.data.imageUrl,
        vin: this.data.vin,
        dealerCategory: this.data?.dealerCategory,
        source: this.data?.source,
        dealerCode: this.data?.dealerCode,
        unitId: this.data?.unitId,
        isSafetyCampaign:this.data.isSafetyCampaign,
        isNonSafetyCampaign:this.data.isNonSafetyCampaign,
      })
      this.isVinValid = true;
      //disable the continue button
      this.disableContinueButton(vehicleData);
    }
  }

  disableContinueButton(data: any) {
    this.showStatusLabel = false;
    if (data.isSafetyCampaign) {
      this.enableSubmitButton = false;
      this.showStatusLabel = true;
      this.vehicleStatusLabel = 'deliveryChecklist.stopSale';
      this.calenderMessage = data.isDealerDifferent ? 'delivery.deliveryButtonDisabled' : 'delivery.campaignOpened';
    }
    else if ((data?.dealerCategory === VehicleStatus.A) || (data?.dealerCategory === VehicleStatus.F) || data.dealerCode !== this.dealerCode) {
      this.enableSubmitButton = false;
      this.showStatusLabel = true;
      this.vehicleStatusLabel = 'deliveryChecklist.pendingVehicleArrival';
      this.calenderMessage = 'delivery.deliveryButtonDisabled';
    }
  }

  onSearchChange(searchValue: string): void {  
    this.vehicleDetails.isInvalid = false
  }

  getTimeSlot(timeSlotId: string) {
    return this.timeSlots.find(x => x.timeSlotId === timeSlotId)?.time;
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.bannerService.show();
    this.setupStore();
    this.deliveryForm.controls.remoteZipCode.setValidators(this.zipValidator());
  }

  backToDashboard() {
    if(this.isUpdate){
       this.router.navigate(['asp/bdc/pending']);
    }else {
      this.router.navigate(['asp/bdc/dashboard']);
    }
  }

  onValueChange() {
    this.subscriptions.valueChange=this.deliveryForm.valueChanges.subscribe(value => {
      this.formChanged=true;

      /* *this code is needed to do the vinsearch for deeplink, once full address loads for the appt*/
      this.paramVinSearch(value);

      if (value.transportationTypeCode && this.lastValue.transportationTypeCode !== value.transportationTypeCode && value.transportationTypeCode === "DEALER") {
        value.remoteZipCode = "";
      }

      /* *this is to choose selected vehicle during edit mode*/
      if(value?.vehicle?.model && this.isUpdate) {
        this.vehicleDetails.yearMakeModel = `${value.vehicle.year} ${value.vehicle.make} ${value.vehicle.model}`;
        this.vehicleDetails.vin = value.vehicle.vin;
        this.vehicleDetails.make = value.vehicle.make;
        if(!this.vehicleDetails?.dealerCode && !this.isFirstTime)
        {
          this.isFirstTime=true;
          this.subscriptions.editVehicleDetails=this.vehicleService.getVehicleDetails({ vin: value?.vehicle?.vin}).subscribe((data)=>{
          const vehicle = {...this.vehicleDetails};
          vehicle.dealerCode=data.data[0].dealerCode;
          vehicle.dealerCategory=data.data[0]?.dealerCategory;
          vehicle.dealerSubCategory=data.data[0]?.dealerSubCategory;
          vehicle.estimatedDealerArrival=data.data[0].estimatedDealerArrival;
          vehicle.source=data.data[0].source;
          vehicle.certificationStatus=data.data[0]?.certificationStatus;
          vehicle.stockNo=data.data[0]?.stockNo || "NA";
          vehicle.unitId=data.data[0]?.unitId;
          vehicle.isSafetyCampaign = data.data[0]?.isSafetyCampaign;
          vehicle.isNonSafetyCampaign = data.data[0]?.isNonSafetyCampaign;
            vehicle.isInvalidCategory = data.data[0].dealerCategory === VehicleStatus.A || data.data[0].dealerCategory === VehicleStatus.F;
            vehicle.isDealerDifferent = data.data[0].dealerCode !== this.dealerCode;
          this.vehicleDetails = {...vehicle};
          /* load availability when the NVI call is completed and vehicle details are available */
          if (this.deliveryForm.get('vehicle.dealerCategory').value !== vehicle.dealerCategory){
            this.deliveryForm.get('vehicle.dealerCategory').setValue(vehicle.dealerCategory)
          }
          this.loadAvailability(this.lastValue);
        })
      }
       }

      const val = {...value}
      delete val.otherVehicles;
      delete val.address.otherAddressChecked;
      delete val.address.otherAddress;
      delete val.vehicle;
      /*Updating storeValue = undefined everytime the form is updated to the initial changes from the state */
      if (this.storeValue && _.isEqual(this.storeValue, val)) {
        this.storeValue = undefined;
        this.isStoreUpdate = false;

        /* for the very first time lastValue, storeValue and value will be equal,
         hence the storeValue will be undefined. To handle this scenario we are
         reassigning the same value from the store*/
        
         /* *if (_.isEqual(this.lastValue, value)) {
            this.storeValue = this.lastValue;
          } */
        
        return;
      }

      if (_.isEqual(this.lastValue, value)) {
        return;
      }
      /* load availability only when dealer code and dealer category are available 
         callAvailability will be true for the first time only */
      if(this.vehicleDetails?.dealerCategory && this.vehicleDetails?.dealerCode)
      {
      if ((value.transportationTypeCode && this.lastValue.transportationTypeCode !== value.transportationTypeCode) || (value.vehicle.vin && this.lastValue.vehicle.vin !== value.vehicle.vin) || (value.availability?.advisorId && this.lastValue.availability?.advisorId !== value.availability.advisorId && this.callAvailability) || this.isFirstTime) {
      this.loadAvailability(value);
      }
      else{
        this.isStoreUpdate = false;
      } 
    }
      if (value?.customer?.emailAddress) {
        value.customer.emailAddress = value.customer.emailAddress.trim();
      }
      /*lastValue keeps changing everytime the form value changes
       (even when the changes are from the initialstate or EditState) */
      this.lastValue = value;

      /*dispatch happens only when the storeValue = undefined which means
      that all the initial changes (initialState and EditState) from store are
      populated in the form and now we are dispatching the changes done by the user*/
      if (!this.storeValue) {
        this.salesAppointmentState.dispatch(new fromActions.UpdateSalesFormData({ value, appointmentType: AppointmentType.DELIVERY }));
      }
    });

  }
  setFormOnEdit(data) {

    const apptData = {
      vehicle: data.vehicle,
      tradeIn: {
        tradeInCheckbox: data.tradeInVehicle ? true : false,
        vehicle: [],
        title: data.title || '',
        trepresentativeInfo: data.representative || '',
        tradeInComments : data.appointmentComments ?  this.getComment(data.appointmentComments, 'Trade-in') : '',
        comments: data.appointmentComments ?  this.getComment(data.appointmentComments, 'Comments-From-Dealer') : ''
      },
      appointment: {
        transportationTypeCode: data.transportationTypeCode,
        availability: {
          timeSlotId: data.timeSlotId,
          advisorId: data.advisorId,
          languageId: data.languageId,
          appointmentStartDate: data.appointmentStartDate
        }
      },
      customer: data.customer,
      address: data.deliveryAddress
    };
    this.setTradeInVehicles(data, apptData);
    this.setAddress(data, apptData);
    // if(data.transportationTypeCode === 'REMOTE') {
    // apptData.address.otherAddressChecked = !!data.address.otherAddress;
    // this.setOtherAddress(data, apptData);
    // }
    this.deliveryForm.patchValue(apptData);
    this.deliveryForm.updateValueAndValidity();
    this.setSummaryDetails(data);
   
  }

  getComment(data, field) {
    let returnComment = '';
    data.split(':::').forEach(comment=> {
      if(comment.includes(field)) {
        returnComment = comment.replace(`${field} - `, '').trim();
      }
    })
    return returnComment;
  }

  setTradeInVehicles(data, apptData) {
    if(data.tradeInVehicle?.length) {
      data.tradeInVehicle?.forEach(tradeInVehicle=> {
        apptData.tradeIn.vehicle.push(this.getTradeInVehicle(tradeInVehicle));
      })
    }
  }

  getTradeInVehicle(tradeInVehicle) {
    return {
      year: tradeInVehicle &&  tradeInVehicle.year ? tradeInVehicle.year : '',
      make: tradeInVehicle && tradeInVehicle.make ? tradeInVehicle.make : '',
      model: tradeInVehicle && tradeInVehicle.model ? tradeInVehicle.model : '',
      vin: tradeInVehicle && tradeInVehicle.vin ? tradeInVehicle.vin : '',
      mileage: tradeInVehicle && tradeInVehicle.mileage ? tradeInVehicle.mileage : 0,
      trim: tradeInVehicle && tradeInVehicle.trim ? tradeInVehicle.trim : '',
      isOwnVehicle : tradeInVehicle && tradeInVehicle.isOwnVehicle ? tradeInVehicle.isOwnVehicle : false
    };
  }

  setAddress(data, apptData) {
    if (!data.deliveryAddress.addressLine1) {
      apptData.address = {
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: '',
        country: countryCd
      };
    }
  }

  setOtherAddress(data, apptData) {
    if (!data.address.otherAddress) {
      apptData.address.otherAddress = {
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      };
    }
  }

  setSummaryDetails(data) {
    this.location = data.transportationTypeCode;
    this.preferredDate = data.appointmentStartDate;
    this.preferredTime = this.getTimeSlot(data.timeSlotId);
  }

  checkPhoneNumber(number){
    if(number && number.length){
    const code = number.substring(0, number.length - 10)
    if(code === '+1' && number.length === 12){
      return true
    }else if(code === '+52' && number.length === 13){
      return true
    }else{
      return false
    }
  }else{
    return false
  }

  }

  checkCustomerForm(){
    const customer = this.deliveryForm.controls.customer.value;
    const hasValidCustomerName = (customer?.customerType !== CustomerType.BUSINESS
      && customer?.firstName?.length > 0
      && customer?.lastName?.length > 0)
      || (customer?.customerType === CustomerType.BUSINESS
      && customer?.businessName?.length > 0);

    return this.deliveryForm.controls.address.value && hasValidCustomerName;
  }

  checkCustomerFormOnSubmit(){
    const customer = this.deliveryForm.controls.customer.value;
    const hasValidCustomerName = (customer?.customerType !== CustomerType.BUSINESS
      && customer?.firstName?.length > 0
      && customer?.lastName?.length > 0)
      || (customer?.customerType === CustomerType.BUSINESS
      && customer?.businessName?.length > 0);

    return this.deliveryForm.controls.address.value
      && customer?.emailAddress?.length
      && hasValidCustomerName
      && this.checkPhoneNumber(customer?.phoneNumber);
  }

  isValidSaveForLaterForm() {
    return (this.appointmentId ? true : this.isVinValid) &&
    this.deliveryForm.controls.vehicle.valid && this.checkCustomerForm() &&
    !this.AvailabilityComponent?.form?.valid;
  }

   isValidSaveAndSendLinkForm() {
    const vehicle: IVehicleDetails = this.deliveryForm.value.vehicle;
    return (this.appointmentId ? true : this.isVinValid) &&
    (vehicle.dealerCategory !== VehicleStatus.A && vehicle.dealerCategory !== VehicleStatus.F )
    && !vehicle.isSafetyCampaign && vehicle.dealerCode === this.dealerCode
    && this.deliveryForm.controls.vehicle.valid && this.checkCustomerForm() &&
    !this.AvailabilityComponent?.form?.valid;
  }

  updateRequestData() {
    const appointment = this.createRequestData();
    appointment.appointmentId = this.appointmentId;
    ['dealerCode', 'dealer', 'stockNumber'].forEach(p => delete appointment[p]);
    return appointment;
  }

  onSubmitting(data) {
   
    if (data) {
      if (!data.isSubmitted) {
        this.isSubmitting = false;
      }
      if (data.isSubmitted) {
        this.isSubmitting = false;
        const urlState = {...data.appointmentData};   
        const navigationExtras: NavigationExtras = {
          queryParams: {
            id: data.appointmentId
          },
          state: {
           appt: urlState,
           totalDuration:this.totalDuration
          }
        };
        this.router.navigate(['asp/bdc/delivery/confirm'],navigationExtras);
      }
    }

  
  }

  onSubmittingSaveForLater(data) {
   
    if (data) {
      if (!data.isSubmitted) {
        this.isSaveForLaterSubmitting = false;
      }
      if (data.isSubmitted) {
        this.isSaveForLaterSubmitting = false;
        this.appointmentId = data.appointmentId;
        this.router.navigate(['asp/bdc/dashboard']);
      }
    }

  
  }

  createRequestData() {
    
    const vehicle = {
      year: this.vehicleDetails.year,
      model: this.vehicleDetails.model,
      trim: 'LE',
      make: this.vehicleDetails.make
    };
    const appointment = this.deliveryForm.get('appointment') as UntypedFormGroup;
    const customer = this.deliveryForm.get('customer').value;
    const tradeIn = this.deliveryForm.get('tradeIn').value;
    const address = this.deliveryForm.get('address').value;

    const apptEmail = customer.emailAddress;
    let deliveryAddress:IAddress = {
      addressLine1:'',
      addressLine2:'',
      state:'',
      city:'',
      zip:'',
      country: countryCd
    }
    if(address){
      deliveryAddress = address
    }
    const appt: IDeliveryAppointment = {
      appointmentType: AppointmentType.DELIVERY,
      dealerCode: '23569',
      emailAddress: apptEmail,
      languageId: appointment.value.availability.languageId,
      advisorId: appointment.value.availability.advisorId,
      timeSlotId: appointment.value.availability.timeSlotId,
      transportationTypeCode: appointment.value.transportationTypeCode,
      appointmentStartDate: appointment.value.availability.appointmentStartDate,
      vehicle,
      customer,
      stockNumber: this.vehicleDetails.stockno,
      appointmentCreatedRoles:['']
    };

    appt.customer.address.country = countryCd;
    appt.customer.otherAddress.country = countryCd;


    if (tradeIn && tradeIn.tradeInCheckbox) {
      delete tradeIn.tradeInCheckbox;
      appt.tradeInVehicle = tradeIn.vehicle;
      if(appt.tradeInVehicle.length > 0) {
        tradeIn.vehicle.forEach((vehicle, index)=> {
          appt.tradeInVehicle[index].mileage = vehicle.mileage === '' ? 0 : +vehicle.mileage;
        })
      } 
      if (tradeIn.title && tradeIn.title !== '') {
        appt.title = tradeIn.title;
      }
      if (tradeIn.trepresentativeInfo && tradeIn.trepresentativeInfo !== '') {
        appt.representative = tradeIn.trepresentativeInfo;
      }
      if (tradeIn.comments && tradeIn.comments !== '') {
        appt.appointmentComments = tradeIn.comments;
      }
    }

    if (!address.otherAddressChecked) {
      delete address.otherAddressChecked;
      delete address.otherAddress;
    }

    if (appointment.value.transportationTypeCode !== 'R001') {
      delete address.address;
      delete address.otherAddressChecked;
      delete address.otherAddress;
    } else {
      delete address.otherAddressChecked;
    }

 

    return JSON.parse(JSON.stringify(appt).replace(/null/g, '""'));
  }

  setupStore(){
    this.setSignedInUserDetails();
    this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({appointmentType: AppointmentType.DELIVERY}));  
    this.availabilityOptions$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptions);
    this.availabilityOptionsLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityOptionsLoading);
    this.availability$ = this.salesAppointmentState.select(fromSelectors.getAvailability);
    this.availabilityLoading$ = this.salesAppointmentState.select(fromSelectors.getAvailabilityLoading);
    this.transportOptions$ = this.salesAppointmentState.select(fromSelectors.getTransportOptions);
    this.remoteZipcodes$ = this.salesAppointmentState.select(fromSelectors.getPMAZipCodes);
    this.yearList$ = this.salesAppointmentState.select(fromSelectors.getYearList);
    this.time$ = this.settingsState.select(fromSettingsSelectors.time);
    this.subscriptions.settings=this.time$.subscribe(time => {
      this.totalDuration = convertMinsToHourMins(time?.deliveryAppointmentDuration + time?.deliveryApptDuration);
    });
    this.subscriptions.generalSettings=this.settingsState.select(fromSettingsSelectors.selectSettings).subscribe(settings => {
      if(settings && Object.entries(settings).length)
      {
        this.settings.time=settings.time;
        this.settings.portal=settings.portal;
        this.settings.dealerInfo=settings.dealerInfo;
        this.settings.isAspCrmIntegrationEnabled=settings.isAspCrmIntegrationEnabled;
        this.settings.isAspDmsIntegrationEnabled=settings.isAspDmsIntegrationEnabled;
        this.settings.isConsumerPortalEnabled=settings.isConsumerPortalEnabled;
        this.settings.isServiceAccessible=settings.isServiceAccessible;
      }
    });
    this.subscriptions.availability = this.availabilityOptions$.subscribe(options => {
      this.hasRemoteLocation = !!options?.transport?.transportOptions?.find(x => x.category === LocationType.REMOTE && x.isActive && x.enableDeliveryType);
    });
    this.subscriptions.apptDetails = this.salesAppointmentState.select(fromSelectors.deliveryAppointmentDetails).subscribe((data) => {
      let value = { ...data };
      if (_.isEqual(this.lastValue, value)) {
        return;
      }
      this.languageId = value?.availability?.languageId;
      this.lastValue = value;
      this.isStoreUpdate = true;

      /*isUpdate -> During edit mode we need to store the state value thats coming in,
       so that we can check the incoming form changes against storeValue
       isStoreUpdate -> Phase 2 (basically used when changes are invoked from state during create mode)*/
      if (this.isUpdate || this.isStoreUpdate) {
        this.storeValue = { ...value };
        this.customerDataOnEdit = value.customer;
        delete this.storeValue?.otherVehicles;
        delete this.storeValue?.address?.otherAddressChecked;
        delete this.storeValue?.address?.otherAddress;
        delete this.storeValue?.vehicle;
      }
      this.deliveryForm.patchValue(value);
      this.checkZipCodes(value.remoteZipCode);
    });
  }

  setSignedInUserDetails() {
    this.customerDetails$ = this.searchCustomersState.select(selectCurrentCustomer);
    this.subscriptions.customerDetails=this.customerDetails$
      .subscribe(customer => {
        const phoneNumber = customer?.phoneNumber ? ( customer?.phoneNumber?.includes('+') ? customer?.phoneNumber : '+1'+ customer?.phoneNumber) : '';
        this.signedInUserDetails = {
          firstName: customer?.firstName || '',
          lastName: customer?.lastName || '',
          emailAddress: !customer?.drvaFlag ? customer?.emailAddress : '',
          phoneNumber: !customer?.drvaFlag ? phoneNumber : ' ',
          customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
          businessName: customer?.businessName || '',
          drvaFlag: customer?.drvaFlag || false
         // customerType: customer?.customerType === CustomerType.BUSINESS ? CustomerType.BUSINESS : CustomerType.INDIVIDUAL,
        //  businessName: customer?.businessName || ''
        };
        this.salesAppointmentState.dispatch(new fromActions.LoadCustomerDetails({ signedInUserDetails: this.signedInUserDetails }));
      });
  }
  zipValidator(): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors => {
      this.transport = this.deliveryForm.value.transportationTypeCode;
      if (this.deliveryForm.value.transportationTypeCode === 'REMOTE' && !this.isValidRemoteZip) {
        return { remoteZipCode: 'Invalid remoteZipcode' };
      } else {
        return null;
      }
    };
  }
  checkZipCodes(value) {
    this.deliveryForm.controls.remoteZipCode.clearValidators();
    if (this.deliveryForm.value.transportationTypeCode === 'REMOTE') {
      this.subscriptions.zipCodes=this.remoteZipcodes$.pipe(
        filter(zip => !!zip?.length),
        take(1)).subscribe(zip => {
          this.remoteValidZipcodes = {pmaZipCodes:zip,isRemote:true};
          this.isValidRemoteZip = zip?.findIndex(x => x === value) !== -1;
          this.deliveryForm.controls.remoteZipCode.setValidators(this.zipValidator());
          this.deliveryForm.controls.remoteZipCode.updateValueAndValidity();
       
      });
    }
  }
  onMonthChange($event: DateTime) {
    this.subscriptions.availabilityDetails=this.salesAppointmentState.select(fromSelectors.getAvailabilityDetails)
       .pipe(take(1))
       .subscribe(details => {
        const date = $event.toFormat(this.dateFormat);
        const advisor =details.advisorId ? details.advisorId : '-1'
         this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
         { date, advisorId: advisor, fniAdvisorId: details.fniAdvisorId || '-1', transport: details.transport, selectDateAndSlot: false , appointmentType: AppointmentType.DELIVERY,appointmentId : this.appointmentId ? this.appointmentId : '' }));
       });

  }
  
  onSubmit(isSaveForLater: boolean) {
    this.formChanged = true;
    if (this.from === 'sendLink' && !isSaveForLater) {
      this.salesAppointmentState.dispatch(new fromActions.updateSentLinkDate())
      const payload = { appointmentType: AppointmentType.DELIVERY, from: this.from,settings:this.settings };
      this.salesAppointmentState.dispatch(new fromActions.CreateSalesAppointment(payload));
    } else if (this.isUpdate && !isSaveForLater) {
      const payload = { appointmentType: AppointmentType.DELIVERY,settings:this.settings }
      this.salesAppointmentState.dispatch(new fromActions.EditSalesAppointment(payload));
    } else {
      const payload = { appointmentType: AppointmentType.DELIVERY ,settings:this.settings};
      this.salesAppointmentState.dispatch(new fromActions.CreateSalesAppointment(payload));
    }
    this.navigateAfterSaving(isSaveForLater);
  }
  
  navigateAfterSaving(isSaveForLater: boolean) {
    this.subscriptions.editDetails = this.salesAppointmentState.select(fromSelectors.editDetails)
      .subscribe((editDetail) => {
        this.formChanged = true;
        isSaveForLater ? this.onSubmittingSaveForLater(editDetail) : this.onSubmitting(editDetail);
      });
  }

  triggerEmailAndSave() {
    const payload = { appointmentType: AppointmentType.DELIVERY, settings: this.settings, from: 'sendLink' };
    this.saveAndSendLink = true;
    this.salesAppointmentState.dispatch(new fromActions.CreateSalesAppointment(payload));
    this.navigateAfterSaving(true);
  }

  onSubmitSaveForLater() {
    this.isSaveForLaterSubmitting = true;
    this.onSubmit(true);
  }

  submitTheAppointment() {
    this.isSubmitting = true;
    this.onSubmit(false);
  }

  get getDisclaimerText() {
    return this.translateService.instant('testDrive.privacyPolicyTxt');
  }

  ngOnDestroy() {
    this.salesAppointmentState.dispatch(new fromActions.ResetSalesAppointmentState());
    unsubscribeSubscriptions(this.subscriptions);
    this.bannerService.update('');
    this.cdref.detach();
  }
  getTranslation(value){
    return value ? `${this.translate.instant(`common.${value}`)}` : value;
  }

  loadAvailability(value) {
    this.isStoreUpdate = true;
    this.isFirstTime = false;
    if (value.vehicle.vin) {
      this.loadingAvailability = false;
      this.disableContinueButton(this.vehicleDetails);
      const chosenDate = value.availability.appointmentStartDate;
      if (this.enableSubmitButton) {
        this.callAvailability = false;
        if (chosenDate) {
          const date = DateTime.fromISO(chosenDate)
            .startOf('month')
            .toFormat('yyyy-MM-dd');
          this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
            {
              selectDateAndSlot: true, date, advisorId: value.availability.advisorId,
              fniAdvisorId: value.availability.fniAdvisorId || '-1',
              transport: value.transportationTypeCode,
              appointmentType: AppointmentType.DELIVERY,
              appointmentId: this.appointmentId ||  ''
            }));
        } else {
          this.salesAppointmentState.dispatch(new fromActions.LoadAvailability(
            {
              selectDateAndSlot: false, date: '', advisorId: value.availability.advisorId,
              fniAdvisorId: value.availability.fniAdvisorId || '-1',
              transport: value.transportationTypeCode,
              appointmentType: AppointmentType.DELIVERY,
              appointmentId: this.appointmentId || ''
            }));
        }
        this.subscriptions.availabilityLoading = this.availabilityLoading$.subscribe(value => {
          if (!value) {
            this.loadingAvailability = true;
          }
          this.load = !this.loadingAvailability;
        })
        if (this.lastValue.transportationTypeCode !== value.transportationTypeCode) {
          this.salesAppointmentState.dispatch(new fromActions.LoadAvailabilityOptions({ appointmentType: AppointmentType.DELIVERY }));
        }
      } else {
        this.load = false;
      }
    }
  }
}
